import IconMore from "./IconMore";

export default function Card({item, onClick, side, className = '', style = {}, ...rest}) {
    return (
        <div 
            {...rest}
            onClick={onClick}
            className={`click-effect bg-navy rounded-[1.875rem] border-[0.25rem] border-[#D9D9D9] w-[34.875rem] ${className}`}
            style={style}>
            <div className='relative px-[3.4375rem] pt-[2.5rem] pb-[2.125rem]'>
                <div className="text-[2.875rem] relative break-words leading-none mb-[1.7rem]" dangerouslySetInnerHTML={{ __html: item.title }}></div>
                <div className="font-light line-clamp-6 text-[2.125rem] leading-none" dangerouslySetInnerHTML={{ __html: item.category }}></div>
                <div className={`absolute w-[3.75rem] h-[3.75rem] rounded-full bg-[#03BCE9] flex items-center justify-center text-white text-[2.375rem] bottom-0 transform translate-y-[50%] ${side === 'left' ? 'right-0 translate-x-1/2' : 'left-0 -translate-x-1/2'}`}>{item.id}</div>
            </div>

            <hr className="border-t-[0.25rem] border-[#D9D9D9] mb-[2.375rem]" />

            <div className="px-[3.4375rem] pb-[2.5rem] flex items-center text-[1.75rem] mt-[2.5rem] leading-none">Read more <IconMore className="w-[1.4rem] h-[1.4rem] ml-[0.8rem]" /></div>
            
        </div>
    );
};
